/* Hide only the recognised supplier postcode notice in the visible description.
   Product data, structured data, shipping rates and checkout are not modified. */
(() => {
  const tidy = value => (value || '').replace(/\s+/g, ' ').trim();
  const summaryText = 'View Complete List of Undeliverable Postcode Suburb Combinations';
  function update(root) {
    root.querySelectorAll('.product__description').forEach(description => {
      const supplierImage = [...description.querySelectorAll('img[src]')].some(img => {
        try { return new URL(img.src, location.href).hostname === 'services.dropshipzone.com.au'; }
        catch (_) { return false; }
      });
      if (!supplierImage) return;
      description.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector(':scope > summary');
        const table = details.querySelector('table');
        if (tidy(summary?.textContent) !== summaryText || !table) return;
        const headings = [...table.querySelectorAll('thead th')].map(e => tidy(e.textContent));
        if (headings[0] !== 'Postcode' || headings[1] !== 'Suburb / Location') return;
        details.classList.add('hmg-supplier-postcodes-hidden');
        details.hidden = true;
      });
      description.querySelectorAll('strong').forEach(heading => {
        if (tidy(heading.textContent) !== 'Shipping Restriction Notice') return;
        const notice = heading.parentElement;
        const message = notice.querySelector(':scope > p');
        if (notice.tagName !== 'DIV' || !message || notice.children.length !== 2) return;
        if (!tidy(message.textContent).startsWith('Shipments to the specific postcode-suburb combinations below are excluded.')) return;
        notice.classList.add('hmg-supplier-postcodes-hidden');
        notice.hidden = true;
        const wrapper = notice.parentElement;
        if (wrapper.tagName === 'DIV' && wrapper.children.length === 1 && tidy(wrapper.textContent) === tidy(notice.textContent)) {
          wrapper.classList.add('hmg-supplier-postcodes-hidden');
          wrapper.hidden = true;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update(document));
  else update(document);
  document.addEventListener('shopify:section:load', event => update(event.target));
})();
